export const initReadyState = (targetElement) => {
  if (!targetElement) {
    return;
  }

  targetElement.classList.add("page--ready");
};
